module.exports = __webpack_public_path__ + "img/lxwm.1824b98b.png";